<script>
  import EditView from '../partials/EditView.vue'
  import FormInput from '../form/form-input.vue'
  import FormLookup from '../form/form-lookup.vue'

  export default {
    components: {
      EditView,
      FormInput,
      FormLookup,
    },
    props: {
      id: {
        type: String,
        required: true
      }
    },
    computed: {
    },
    watch: {
    }
  }
</script>
<template>
  <edit-view
    :id="id"
    v-slot="slotProps"
    store="repositoryconstraint"
    list-route="RepositoryConstraintList"
  >
    <form-lookup
      :store="slotProps.store"
      :translation-root="slotProps.translationRoot"
      prop-name="repository"
      class="col-6"
    >
      <template #selected-item="bundleProps">
        {{ bundleProps.item.name }}
      </template>
      <template #item="bundleProps">
        {{ bundleProps.item.name }}
      </template>
    </form-lookup>
    <form-lookup
      :store="slotProps.store"
      :translation-root="slotProps.translationRoot"
      prop-name="packageDescriptor"
      class="col-6"
    >
      <template #selected-item="descriptorProps">
        {{ descriptorProps.item.name }}
      </template>
      <template #item="descriptorProps">
        {{ descriptorProps.item.name }}
      </template>
    </form-lookup>
    <form-input
      :store="slotProps.store"
      prop-name="constraintText"
      class="col-3"
    />
  </edit-view>
</template>
